import React from 'react';
import { Container } from 'react-bootstrap';
import { Redirect, Route, Switch } from 'react-router-dom';

import retryLazy from '../retry-lazy';

import Suspense from '../../shared/components/suspense';
import ErrorBoundaryWrapper from '../../shared/components/error-boundary-wrapper';

import { IProps } from './type';
import EmailAccountsFallback from './components/fallbacks/email-accounts-fallback';

const EmailAccountsContent = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "email-accounts-content" */ './components/email-accounts-content'
      ),
  ),
);

const UpdateEmailAccount = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "update-email-account" */ './components/email-accounts-content/components/update-email-account'
      ),
  ),
);

const CreateEmailInfrastructure = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "create-email-infrastructure" */ './components/create-email-infrastructure'
      ),
  ),
);

const AddEmailAccounts = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "add-email-accounts" */ './components/add-email-accounts'
      ),
  ),
);

const CreateConnectEmailAccount = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "create-connect-email-account" */ './components/create-connect-email-account'
      ),
  ),
);

const EmailAccounts: React.FC<IProps> = () => (
  <Container fluid className="email-accounts-container">
    <ErrorBoundaryWrapper>
      <Switch>
        <Route exact path="/email-accounts/create-email-accounts">
          <Suspense>
            <CreateEmailInfrastructure />
          </Suspense>
        </Route>

        <Route exact path="/email-accounts/add-email-accounts">
          <Suspense>
            <AddEmailAccounts />
          </Suspense>
        </Route>

        <Route exact path="/email-accounts/:hashId/:tab">
          <Suspense>
            <UpdateEmailAccount />
          </Suspense>
        </Route>

        <Route exact path="/email-accounts">
          <Suspense fallback={<EmailAccountsFallback />}>
            <EmailAccountsContent />
          </Suspense>
        </Route>

        <Route exact path="/email-accounts/create">
          <Suspense>
            <CreateConnectEmailAccount />
          </Suspense>
        </Route>
        <Redirect to="/email-accounts" />
      </Switch>
    </ErrorBoundaryWrapper>
  </Container>
);

export default EmailAccounts;
